import { useTranslation } from 'next-i18next';

export const useArticleCategoryName = (category?: string) => {
  const { t } = useTranslation('articles');

  if (!category) return null;

  return {
    'before-the-big-day': t('categoryName.beforeTheBigDay'),
    engagement: t('categoryName.engagement'),
    'budget-and-costs': t('categoryName.budgetCosts'),
    'ceremony-and-vows': t('categoryName.ceremonyVows'),
    'wedding-speeches': t('categoryName.speeches'),
    'wedding-fashion': t('categoryName.weddingFashion'),
    'wedding-flowers': t('categoryName.flowers'),
    'wedding-decor-styling': t('categoryName.decorStyling'),
    'wedding-food-and-drink': t('categoryName.foodDrink'),
    'wedding-entertainment-music': t('categoryName.entertainmentMusic'),
    'wedding-stationery-wording': t('categoryName.stationeryWording'),
    venues: t('categoryName.venues'),
    'stag-and-hen': t('categoryName.preWeddingParties'),
    'wedding-guests-gifting': t('categoryName.guestsGifting'),
    'honeymoons-travel': t('categoryName.honeymoonsTravel'),
    'love-relationships': t('categoryName.loveRelationships'),
    'real-weddings': t('categoryName.realWeddings'),
  }[category];
};
